import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * SalesLayout: thin passthrough.
 *
 * The All Apps panel that used to live here is now provided by AppLayout
 * via its `panel` prop (set in src/routes/authedRoutes.tsx based on pathname),
 * and the icons + sub-items come from src/components/Sidebar/constants.tsx
 * through src/components/AllAppsLayout/AllAppsLayout.tsx.
 *
 * This file stays so nested Sales routes keep rendering through an Outlet,
 * and so sales-specific wrappers (page title context, feature flags, etc.)
 * can be added here later without touching every nested route.
 */
export default function SalesLayout(): React.ReactElement {
  return <Outlet />;
}
